// @flow strict
import * as React from 'react'

import styles from './Card.module.scss'

export type Props = { children: string }

export default (props: Props) => <p className={styles.text}>{props.children}</p>
